/**
 * Maps the errors object from the react-hook-form validation schema to an array of objects that can be sent to the tracking service.
 * @param {object} errors - The errors object from the react-hook-form validation schema
 * @returns {Array<object>} An array of objects containing the field name and error message
 */
export function formErrorsToTrackingErrorsMapper(errors) {
  return Object.entries(errors).map(([field, error]) => ({
    formField: field,
    errorMessage: error.message
  }));
}
